import axios from 'axios'
import {
    AssaysViewApplyProtocolsRequest,
    AssaysViewPortionResponse,
    AssaysViewPortionsCancelRequest,
    HierarchicalPortionTreeRequest,
    HierarchicalSampleTreeRequest
} from '@/components/assays-view/services/assays-view-portion/assays-view-portion.dto'

class AssaysViewPortionService {
    async applyPortions(
        laboratoryId: number,
        caseId: number,
        assaysViewApplyProtocolsRequest: AssaysViewApplyProtocolsRequest
    ): Promise<void> {
        const response =
            await axios.post<void>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/applyProtocols`,
                assaysViewApplyProtocolsRequest)
        return response.data
    }

    async cancelPortions(
        laboratoryId: number,
        caseId: number,
        portionsCancelRequests: AssaysViewPortionsCancelRequest[]
    ): Promise<void> {
        const response =
            await axios.put<void>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/cancelBatch`,
                portionsCancelRequests)
        return response.data
    }

    async createPortions(
        laboratoryId: number,
        caseId: number,
        copies: number,
        hierarchicalSampleTreeRequests: HierarchicalSampleTreeRequest[],
        portionTypeId?: number
    ): Promise<AssaysViewPortionResponse[]> {
        const response =
            await axios.post<AssaysViewPortionResponse[]>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/createBatch`,
                hierarchicalSampleTreeRequests,
                {
                    params: {
                        copies,
                        portionTypeId
                    }
                })
        return response.data
    }

    async deletePortions(
        laboratoryId: number,
        caseId: number,
        hierarchicalPortionTreeRequests: HierarchicalPortionTreeRequest[]
    ): Promise<void> {
        const response =
            await axios.delete<void>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/deleteBatch`,
                { data: hierarchicalPortionTreeRequests })
        return response.data
    }
}

export const assaysViewPortionService = new AssaysViewPortionService()
